import React, { useEffect, useRef, useState } from "react";
import TicketTat from "../commonWidgets/TicketTat";
import { useDispatch, useSelector } from "react-redux";
import { useScrollPosition } from "@n8tb1t/use-scroll-position";
import { useHistory, useLocation } from "react-router-dom";
import { Button } from "antd";
import { setActiveSectionKey } from "../../../redux/actions/section/section";
import somethingWentWrong from "../../../assets/No_Data_Found.svg";
import {
  setConfiguration,
  setPreWidgetsData,
} from "../../../redux/actions/ApiCall";
import { getCustomizedDate } from "../../../redux/constants";
import { getPaneIndex, getTimeInterval } from "../../../redux/constants";
import moment from "moment";
import {
  setSelectedTatWidgetMonth,
  setSelectedTatTitleMonth,
} from "../../../redux/actions/ApiCall/apiCall";
import { setSimpleViewDuration } from "../../../redux/actions/dashboard/Tab1";

const TicketTATSimpleViewSection = ({ dashboardData }) => {
  const divRef = useRef();
  const history = useHistory();
  const dispatch = useDispatch();

  const authParams = useSelector((state) => state?.Authentication?.authParams);
  const panes = useSelector((state) => state?.Tab1?.panes);
  const activeKey = useSelector((state) => state?.Tab1?.activeKey);
  let index = getPaneIndex(panes, activeKey);

  const sectionTwoData = panes[index]?.sections[1]?.widgets;

  const selectedDate = panes[index]?.duration;
  const Allbrands = useSelector(
    (state) => state.ApiCall.brands?.data?.result?.brands
  );
  const brandlogicalgroup = useSelector(
    (state) => state.ApiCall.brandlogicalgroup?.data?.result
  );
  const selectedBrands = panes[index]?.brands?.columns;

  const selectedTatWidgetMonth = useSelector(
    (state) => state?.ApiCall?.selectedTatWidgetMonth
  );
  const TitleMonth = useSelector(
    (state) => state?.ApiCall?.selectedTatTitleMonth
  );

  const sections = panes?.[index]?.sections;
  const activeSectionKey = useSelector(
    (state) => state?.Section?.activeSectionKey
  );
  const preWidgetLoader = useSelector(
    (state) => state?.apiCall?.preWidgetLoader
  );
  const preTicketLoader = useSelector(
    (state) => state.apiCall.ticketWidgetLoader
  );

  const setdivHeightRange = () => {
    const sectionData = sections?.map((el, i) => {
      if (el.section_id === divRef?.current?.id) {
        el.divHeight = divRef?.current?.clientHeight;
      }
      return el;
    });
    let divHeight = sectionData?.map((el) => {
      return el.divHeight;
    });

    let arr = [];
    divHeight?.map((el, i) => {
      if (i == 0) {
        arr.push({ start: 0, end: el });
      } else {
        let value = { start: arr[i - 1].end, end: arr[i - 1].end + el };
        arr.push(value);
      }
    });
    return arr;
  };

  const setActivekey = (top, arr) => {
    arr?.map((el, i) => {
      if (top >= el?.start && top < el?.end) {
        dispatch(setActiveSectionKey(sections[i].section_id));
      }
    });
  };

  useScrollPosition(
    ({ currPos }) => {
      const arr = setdivHeightRange();
      setActivekey(window.pageYOffset, arr);
    },
    [sections, activeSectionKey],
    divRef,
    false,
    1000
  );

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const date = panes[index]?.duration?.from
    ? new Date(panes[index]?.duration?.from)
    : new Date();

  useEffect(() => {
    if (selectedTatWidgetMonth === 1) {
      let month = months[date.getMonth()];
      let convertedMonth = moment().month(month).format("M");
      let dynamicYear = moment().year();

      let startDate = moment([dynamicYear, convertedMonth]);
      let endDate = moment(startDate).endOf("month");
      dispatch(
        setSelectedTatTitleMonth({
          from: moment(startDate).format("DD MMM YYYY"),
          to: moment(endDate).format("DD MMM YYYY"),
        })
      );
    }
  }, []);

  const handleChangeSendDate = (num, month, year) => {
    dispatch(setSelectedTatWidgetMonth(num));
    let convertedMonth = moment().month(month).format("M");
    let dynamicYear = year;

    let startDate = moment([dynamicYear, convertedMonth - 1]);
    let endDate = moment(startDate).endOf("month");

    let customDate = {
      from: moment(startDate).format("YYYY/MM/DD 00:00"),
      to: moment(endDate).format("YYYY/MM/DD 23:59"),
    };
    dispatch(setSimpleViewDuration(customDate, panes, index));

    dispatch(
      setSelectedTatTitleMonth({
        from: moment(startDate).format("DD MMM YYYY"),
        to: moment(endDate).format("DD MMM YYYY"),
      })
    );

    const d = new Date();
    let utcOffset = d.getTimezoneOffset();
    let twoMonthsDuration = getCustomizedDate(6, "Days");
    let defaultDuration = {
      from:
        moment(twoMonthsDuration?.date[0]).format("YYYY/MM/DD") +
        " " +
        twoMonthsDuration?.time?.startTime,
      to:
        moment(twoMonthsDuration?.date[1]).format("YYYY/MM/DD") +
        " " +
        twoMonthsDuration?.time?.endTime,
    };

    let getInterval = getTimeInterval(
      selectedDate ? selectedDate?.to : defaultDuration?.to,
      selectedDate ? selectedDate?.from : defaultDuration?.from
    );

    // mapping
    sectionTwoData?.map((sec, i) => {
      sec.graphData = null;
      let indexes = {
        pane_index: index,
        section_index: 1,
        panes: panes,
        widget_index: i,
      };
      let graphObject = {
        authParams: authParams,
        role_type: -1,
        brands: selectedBrands
          ? Array.isArray(selectedBrands)
            ? selectedBrands
            : [selectedBrands]
          : Allbrands,
        isBrandModified: selectedBrands ? true : false,
        duration: customDate,
        widget_id: sec.widget_id,
        chart_type:
          typeof getInterval?.defaultVal === "string"
            ? getInterval?.defaultVal
            : null,
        interval:
          typeof getInterval?.defaultVal === "number"
            ? getInterval?.defaultVal
            : null,
        benchmark_breach: null,
        filters: sec?.filters
          ? sec.filters
          : sec?.payload?.filters
          ? sec?.payload?.filters
          : null,
        is_modified_date:
          panes?.[index]?.template_id === "000-000-002" ||
          panes?.[index]?.template_id === "000-000-004"
            ? panes?.[index]?.is_modified_date
              ? panes?.[index]?.is_modified_date
              : false
            : null,
      };

      authParams?.category_id &&
        dispatch(setPreWidgetsData(graphObject, indexes));
    });
    //setIschangesDate('gggg');
  };

  return (
    <div
      className="pb-15"
      ref={divRef}
      name={dashboardData?.section_id}
      id={dashboardData?.section_id}
      key={dashboardData?.section_id}
    >
      <div
        className="portlet1 p-10 border-radius-4 line-height-normal mb-15"
        style={{
          backgroundColor:
            authParams?.theme_type === "1"
              ? "rgb(59 81 117 / 50%)"
              : "rgba(255, 255, 255, 0.3)",
        }}
      >
        <div className="text_heading-Slab d-flex align-items-center justify-content-between font-size16 font-weight500">
          <span>
            {dashboardData?.section_name}{" "}
            {/* {dashboardData?.section_id === "tickets_simple-view_section-2" &&
            TitleMonth &&
            `(${TitleMonth?.from} To ${TitleMonth?.to})`} */}
            {dashboardData?.section_id === "tickets_simple-view_section-2" && (
              <>
                (
                {moment(panes[index]?.simple_view_duration?.from).format(
                  "DD MMM YYYY"
                )}{" "}
                To &nbsp;
                {moment(panes[index]?.simple_view_duration?.to).format(
                  "DD MMM YYYY"
                )}
                )
              </>
            )}
          </span>
          {dashboardData?.section_id === "tickets_simple-view_section-2" && (
            <div>
              <Button
                type={selectedTatWidgetMonth == "0" ? "primary" : ""}
                className={`mr-15 ${
                  selectedTatWidgetMonth == "0"
                    ? "ant-btn-primary_blue"
                    : "btn_Clear"
                }`}
                onClick={() =>
                  handleChangeSendDate(
                    "0",
                    moment(date).subtract(1, "months").format("MMMM"),
                    moment(date).subtract(1, "months").format("YYYY")
                  )
                }
              >
                {/* {months[date.getMonth() - 1] + " " + date.getFullYear()} */}
                {moment(date).subtract(1, "months").format("MMMM YYYY")}
              </Button>
              <Button
                type={selectedTatWidgetMonth == "1" ? "primary" : "button"}
                className={`${
                  selectedTatWidgetMonth == "1"
                    ? "ant-btn-primary_blue"
                    : "btn_Clear"
                }`}
                onClick={() =>
                  handleChangeSendDate(
                    "1",
                    moment(date).format("MMMM"),
                    moment(date).format("YYYY")
                  )
                }
              >
                {moment(date).format("MMMM YYYY")}
                {/* {months[date.getMonth()] + " " + date.getFullYear()} */}
              </Button>
            </div>
          )}
        </div>
      </div>
      {dashboardData?.widgets ? (
        dashboardData?.widgets?.map((el, i) => {
          if (el?.graphData?.data) {
            return (
              <TicketTat
                widgetsData={el}
                widgetName={el?.widget_name}
                widgetDec={el?.widget_description}
              />
            );
          } else if (
            preTicketLoader?.widget_id === el?.widget_id &&
            preTicketLoader?.value &&
            preWidgetLoader
          ) {
            return (
              <div className="loader portlet1 mb-15 text-center w-100">
                <div className="lds-ring">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
            );
          } else if (
            typeof el?.graphData === "string" &&
            !preTicketLoader?.value &&
            !preWidgetLoader
          ) {
            return (
              <div className="portlet1 p-0 mb-15">
                <div className="d-flex full_nodata align-items-center">
                  <div className="w-100 text-center">
                    <div className="Nodata_img mb-15">
                      <img src={somethingWentWrong} alt="no data" />
                    </div>
                    <div className="text_regular-gray">No Data Found</div>
                  </div>
                </div>
              </div>
            );
          } else {
            return (
              <div className="loader portlet1 mb-15 text-center w-100">
                <div className="lds-ring">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
            );
          }
        })
      ) : (
        <div className="loader portlet1 mb-15 text-center w-100">
          <div className="lds-ring">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TicketTATSimpleViewSection;
